import Service, { inject as service } from '@ember/service';

export default class NotificationPreferenceCommands extends Service {
  @service api;
  @service shData;
  @service store;

  update(notificationPreference, {
    status,
    startAt = undefined,
    endAt = undefined,
  }) {
    const jsonData = {
      status,
    };

    if (startAt !== undefined) {
      jsonData.startAt = startAt;
    }

    if (endAt !== undefined) {
      jsonData.startAt = endAt;
    }

    return this.api.put(`notification-preferences/${notificationPreference.id}`, {
      jsonData
    });
  }
}
